import { authFetch, ExamAuthFetch } from "../../../../api";

export const getUserDetails = async (userId) => {
  try {
    const response = await authFetch(`stm-route/sp-user-detail/${userId}`, {
      method: "GET",
    });
    if (!response.ok) {
      // Handle API error (401, 403, 500, etc.)
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch user details");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Failed to fetch user details:", err.message);
  }
};

export const getTestTypeByUser = async (userId) => {
  try {
    const response = await authFetch(`stm-route/testtype-byuser/${userId}`, {
      method: "GET",
    });
    if (!response.ok) {
      // Handle API error (401, 403, 500, etc.)
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch user details");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Failed to fetch user details:", err.message);
  }
};

export const editGoalApi = async (requestData) => {
  try {
    const response = await authFetch("selfevaluation", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("Error creating course:", err.message);
  }
};

export const getDashboardClasses = async (requestData) => {
  try {
    const response = await authFetch("stm-route/class-search", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });
    if (!response.ok) {
      // Handle API error (401, 403, 500, etc.)
      const errorData = await response.json();
      throw new Error(errorData.message || "Data could't find");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Data could't find:", err.message);
  }
};

export const getClassesFilter = async (requestData) => {
  try {
    const response = await authFetch("stm-route/class-search-filter", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });
    if (!response.ok) {
      // Handle API error (401, 403, 500, etc.)
      const errorData = await response.json();
      throw new Error(errorData.message || "Data could't find");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Data could't find:", err.message);
  }
};

export const getTestTypeList = async () => {
  try {
    const response = await authFetch(`testtype`, {
      method: "GET",
    });
    if (!response.ok) {
      // Handle API error (401, 403, 500, etc.)
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch test types");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Failed to fetch test types:", err.message);
  }
};

export const getSubTestTypeList = async (testTypeId) => {
  try {
    const response = await authFetch(`stm-route/subtesttype/${testTypeId}`, {
      method: "GET",
    });
    if (!response.ok) {
      // Handle API error (401, 403, 500, etc.)
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch sub test types");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Failed to fetch sub test types:", err.message);
  }
};

export const getDeliveryModes = async () => {
  try {
    const response = await authFetch(`stm-route/class-delivery-mode`, {
      method: "GET",
    });
    if (!response.ok) {
      // Handle API error (401, 403, 500, etc.)
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch delivery modes");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Failed to fetch delivery modes:", err.message);
  }
};

export const getTestDeliveryFormat = async () => {
  try {
    const response = await authFetch(`testdeliveryformat`, {
      method: "GET",
    });
    if (!response.ok) {
      // Handle API error (401, 403, 500, etc.)
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch delivery modes");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Failed to fetch delivery modes:", err.message);
  }
};

export const getBranchList = async () => {
  try {
    const response = await authFetch(`branches`, {
      method: "GET",
    });
    if (!response.ok) {
      // Handle API error (401, 403, 500, etc.)
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch branches");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Failed to fetch branches:", err.message);
  }
};

// get wishlist items

export const getWishListItems = async (userId) => {
  try {
    const response = await authFetch(`stm-route/class-wishlist/${userId}`, {
      method: "GET",
    });
    if (!response.ok) {
      // Handle API error (401, 403, 500, etc.)
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch data");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Failed to fetch data:", err.message);
  }
};

export const removeOneItem = async (requestData) => {
  try {
    const response = await authFetch("class-wishlist", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });
    if (!response.ok) {
      // Handle API error (401, 403, 500, etc.)
      const errorData = await response.json();
      throw new Error(errorData.message || "error  to remove data");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("error  to remove data:", err.message);
  }
};

export const addOneItem = async (requestData) => {
  try {
    const response = await authFetch("class-wishlist", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });
    if (!response.ok) {
      // Handle API error (401, 403, 500, etc.)
      const errorData = await response.json();
      throw new Error(errorData.message || "Added Succefully");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("error  to add data:", err.message);
  }
};

export const removeWishlistAllItem = async (userId) => {
  try {
    const response = await authFetch(`class-wishlist/${userId}`, {
      method: "Delete",
      headers: { "Content-Type": "application/json" },
    });
    if (!response.ok) {
      // Handle API error (401, 403, 500, etc.)
      const errorData = await response.json();
      throw new Error(errorData.message || "Removed all item succefully");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Removed all item succefully", err.message);
  }
};

// search demo
export const searchDemo = async (requestData) => {
  try {
    const response = await authFetch("stm-route/search-demo", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching demos :", err.message);
  }
};

// Book Demo

export const bookDemo = async (requestData) => {
  try {
    const response = await authFetch("demo", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("Error sending data :", err.message);
  }
};

// get upcomming demos
export const getUpcommingDemos = async (userId) => {
  try {
    const response = await authFetch(
      `stm-route/upcoming-demo-byuser/${userId}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
    );

    const data = await response.json();

    return data;
  } catch (err) {
    console.error("error to fetch demos", err.message);
  }
};

export const getPastDemos = async (userId) => {
  try {
    const response = await authFetch(`stm-route/past-demo-byuser/${userId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error("error to fetch demos", err.message);
  }
};

// Cancel Demo
export const cancelDemo = async (requestData) => {
  try {
    const response = await authFetch("demo/cancel", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("cant cancel the demo  :", err.message);
  }
};

export const searchDemoDates = async (requestData) => {
  try {
    const response = await authFetch("stm-route/search-demo-seat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("cant search demo  :", err.message);
  }
};

export const rescheduleDemo = async (requestData) => {
  try {
    const response = await authFetch("demo/reschedule", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("cant reschedule demo  :", err.message);
  }
};

export const getCancelAndRescheduleReasons = async (id) => {
  try {
    const response = await authFetch(
      `stm-route/demo-reschedule-cancel-reason/${id}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
    );

    const data = await response.json();

    return data;
  } catch (err) {
    console.error("error to fetch reasons", err.message);
  }
};

// evalution api
export const getEvaluationData = async (requestData) => {
  try {
    const response = await authFetch("stm-route/demo-evalution-status", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("cant find evalution report  :", err.message);
  }
};

export const getPackages = async (requestData) => {
  try {
    const response = await authFetch("stm-route/get-packages", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("cant find packages  :", err.message);
  }
};

// getEnrolslots
export const getEnrolSlot = async (requestData) => {
  try {
    const response = await authFetch("stm-route/enrol-slot", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("cant find slots  :", err.message);
  }
};

export const createEnrollEnquiry = async (requestData) => {
  try {
    const response = await authFetch("stm-route/create-enroll-enquiry", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't create enquiry  :", err.message);
  }
};

export const getCountries = async () => {
  try {
    const response = await authFetch("route/country", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch countries  :", err.message);
  }
};

export const getStateByCountry = async (countryId) => {
  try {
    const response = await authFetch(`route/statebycountry/${countryId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch states  :", err.message);
  }
};

export const getCityByState = async (stateId) => {
  try {
    const response = await authFetch(`route/citybystate/${stateId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch Cities  :", err.message);
  }
};

// Rezorpay api
export const genrateProvisionalPayment = async (requestData) => {
  try {
    const response = await authFetch("lmprovisionalpayment", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't checkout  :", err.message);
  }
};

// save rezorpay payment

export const saveRezorpayPayment = async (requestData) => {
  try {
    const response = await authFetch(
      "lmprovisionalpayment/std-razorpay-payment",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      },
    );

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't Save Details  :", err.message);
  }
};

// get default address
export const getAdressOfUser = async (requestData) => {
  try {
    const response = await authFetch("user-address/fetch-address", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't Fetch Addresss :", err.message);
  }
};

// save Address
export const saveUserAddress = async (requestData) => {
  try {
    const response = await authFetch("user-address/add-address", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't save address :", err.message);
  }
};

export const deleteUserAddress = async (requestData) => {
  try {
    const response = await authFetch("user-address/delete-address", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't delete address :", err.message);
  }
};

export const editUserAddress = async (requestData) => {
  try {
    const response = await authFetch("user-address/edit-address", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't edit address :", err.message);
  }
};

export const fetchEnrolledClass = async (requestData) => {
  try {
    const response = await authFetch("stm-route/get-enrolled-classes", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch classes :", err.message);
  }
};

// fetch selected class details
export const fetchEnrolledClassDetails = async (requestData) => {
  try {
    const response = await authFetch("stm-route/view-enrolled-class", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch class details :", err.message);
  }
};

// order api

export const handleFetchOrderApi = async (requestData) => {
  try {
    const response = await authFetch("lmprovisionalpayment/create-order", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't create order:", err.message);
  }
};

// veryfypayment api
export const handleVerifyPayment = async (requestData) => {
  try {
    const response = await authFetch("lmprovisionalpayment/verify-payment", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't verify Payment :", err.message);
  }
};

// class extension order api
export const handleFetchClassExtensionOrderApi = async (requestData) => {
  try {
    const response = await authFetch(
      "lmprovisionalpayment/class-extension-order",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      },
    );

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't create order  :", err.message);
  }
};

export const getAttendanceRecord = async (requestData) => {
  try {
    const response = await authFetch(`stm-route/get-attendance`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch attendance record  :", err.message);
  }
};

export const getAttendanceDetails = async (requestData) => {
  try {
    const response = await authFetch(`stm-route/attendance-detail`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch attendance details  :", err.message);
  }
};

export const getCalandarAttendanceDetails = async (requestData) => {
  try {
    const response = await authFetch(`stm-route/attendance-calender`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch attendance details  :", err.message);
  }
};

export const handleSendLeaveRequest = async (requestData) => {
  try {
    const response = await authFetch(`std-leave`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't send leave request  :", err.message);
  }
};

export const handleFetchLeaveRequest = async (requestData) => {
  try {
    const response = await authFetch(`stm-route/leave-filter`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch leave request  :", err.message);
  }
};

export const handleCanceleaveRequest = async (requestData, rowId) => {
  try {
    const response = await authFetch(`std-leave/cancel-delete`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't canceled leave request  :", err.message);
  }
};

export const handleFetchClassLeaveCalandar = async (requestData) => {
  try {
    const response = await authFetch(`std-leave/classleave-calender`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't find dates  :", err.message);
  }
};

export const editLeaveRequest = async (requestData, rowId) => {
  try {
    const response = await authFetch(`std-leave/${rowId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't edit leave request  :", err.message);
  }
};

export const getClasses = async (userId) => {
  try {
    const response = await authFetch(`stm-route/classes-byuser/${userId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch classes  :", err.message);
  }
};

export const getPayments = async (requestData) => {
  try {
    const response = await authFetch(`stm-route/payment-history`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch payments  :", err.message);
  }
};

export const getPaymentModes = async () => {
  try {
    const response = await authFetch(`stm-route/payment-mode`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch  payment modes :", err.message);
  }
};

export const genratePaymentReceipt = async (requestData) => {
  try {
    const response = await authFetch(`stm-route/receipt`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch generate receipt :", err.message);
  }
};

export const getPaymentStatus = async () => {
  try {
    const response = await authFetch(`stm-route/payment-status`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch payment status :", err.message);
  }
};

export const getRealTestTestTypes = async (userId) => {
  try {
    const response = await authFetch(`real-test-master/test-type/${userId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    let data;
    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch test types  :", err.message);
  }
};

// export const getBlocgsData = async (requestData) => {
//   try {
//     const response = await authFetch("stm-route/class-search", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(requestData),
//     });
//     if (!response.ok) {
//       // Handle API error (401, 403, 500, etc.)
//       const errorData = await response.json();
//       throw new Error(errorData.message || "Data could't find");
//     }
//     const data = await response.json();

//     return data;
//   } catch (err) {
//     console.error("Data could't find:", err.message);
//   }
// };

// export const DashboardStudentExamData = async (requestData) => {
//   try {
//     const response = await ExamAuthFetch("dashboard-student-exam-data", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(requestData),
//     });

//     let data;

//     data = await response.json();
//     return data;
//   } catch (err) {
//     console.error("can't create enquiry  :", err.message);
//   }
// };

// export const DashboardStudentExamData = async (requestData) => {
//   try {
//     const response = await authFetch(
//       "real-test-master/dashboard-student-exam-data",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(requestData),
//       },
//     );

//     let data;

//     data = await response.json();
//     return data;
//   } catch (err) {
//     console.error("can't create enquiry  :", err.message);
//   }
// };

export const DashboardStudentExamData = async () => {
  try {
    const response = await fetch(
      "http://192.168.1.8:94/api/dashboard-student-exam-data?student_number=4411707754&category_id=1",
      // "http://192.168.1.8:94/api/student-all-exam-data?student_number=4411707754&category_id=3&subModule=5&questionSpecific=1",
      {
        method: "GET",
      },
    );

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Can't fetch dashboard student exam data:", err.message);
  }
};



// export const getPerformanceOverallData = async (requestData) => {
//   try {
//     const response = await ExamAuthFetch("overall-progress-graph-api", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(requestData),
//     });

//     let data;

//     data = await response.json();
//     return data;
//   } catch (err) {
//     console.error("can't create enquiry  :", err.message);
//   }
// };

export const getPerformanceOverallData = async (requestData) => {
  try {
    const response = await authFetch(
      "real-test-master/overall-progress-graph-api",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      },
    );

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't create enquiry  :", err.message);
  }
};

// export const getPerformanceCamparisonData = async (requestData) => {
//   try {
//     const response = await ExamAuthFetch("last-3-progress-graph-api", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(requestData),
//     });

//     let data;

//     data = await response.json();
//     return data;
//   } catch (err) {
//     console.error("can't create enquiry  :", err.message);
//   }
// };

export const getPerformanceCamparisonData = async (requestData) => {
  try {
    const response = await authFetch(
      "real-test-master/last-3-progress-graph-api",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      },
    );

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't create enquiry  :", err.message);
  }
};

export const GetTestMasterIssEnroll = async (userId) => {
  try {
    const response = await authFetch(`real-test-master/is-enrolled/${userId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch details  :", err.message);
  }
};

// export const GetExamNameData = async (requestData) => {
//   try {
//     const response = await ExamAuthFetch("exam-name-data", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(requestData),
//     });

//     let data;

//     data = await response.json();
//     return data;
//   } catch (err) {
//     console.error("can't fetch exam names :", err.message);
//   }
// };




export const GetExamNameData = async (requestData) => {
  try {
    const response = await authFetch("real-test-master/exam-name-data", {
      //exam Bifercation   
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch exam names :", err.message);
  }
};

// export const GetStudentAllExamNameData = async (requestData) => {
//   try {
//     const response = await ExamAuthFetch("student-all-exam-data", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(requestData),
//     });

//     let data;

//     data = await response.json();
//     return data;
//   } catch (err) {
//     console.error("can't All Exam Data :", err.message);
//   }
// };

export const GetStudentAllExamNameData = async (requestData) => {
  try {
    const response = await authFetch("real-test-master/student-all-exam-data", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't All Exam Data :", err.message);
  }
};

export const getTestPaymentHistory = async (requestData) => {
  try {
    const response = await authFetch(`stm-route/rt-payment-history`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch payments  :", err.message);
  }
};

export const getAllSubTestTypeList = async () => {
  try {
    const response = await authFetch(`subtesttype`, {
      method: "GET",
    });
    if (!response.ok) {
      // Handle API error (401, 403, 500, etc.)
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch test types");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Failed to fetch test types:", err.message);
  }
};

export const getOneActiveClassDetails = async (userId) => {
  try {
    const response = await authFetch(
      `stm-route/dashboard-std-active-class/${userId}`,
      {
        method: "GET",
      },
    );
    if (!response.ok) {
      // Handle API error (401, 403, 500, etc.)
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch test types");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Failed to fetch test types:", err.message);
  }
};

export const GetStudentDashboardCalander = async (requestData) => {
  try {
    const response = await authFetch("stm-route/dashboard-calender", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch calander data :", err.message);
  }
};

export const GetStudentDashboardDemoAndClassData = async (requestData) => {
  try {
    const response = await authFetch("stm-route/dashboard-calender-day", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch demo and class data :", err.message);
  }
};
